import {
  HfsOperationStatus,
  InfoItemEnum,
  SecondaryStatusRoboticMowerEnum,
} from 'fleet-data-model';
import type {
  AssetOperationExecuteResponse,
  RoboticMowersSummaryItem,
} from '@fleet-bffs/api-contract';
import { OperationStatus } from '~/domain/assets/models';
import type { RoboticMowersSummaryFootprintItem } from '../models/RoboticMowersSummaryFootprintItem';

export const findIndex = (items: RoboticMowersSummaryItem[], iprId: AssetId) =>
  items.findIndex((asset) => asset.iprId === iprId);

export const calculateFootprint = (
  items: RoboticMowersSummaryItem[]
): RoboticMowersSummaryFootprintItem[] =>
  items.map((item) => ({
    iprId: item.iprId,
    operationalStatusTimestamp: item?.status?.operationalStatus?.sourceDataTimestamp,
    secondaryStatusTimestamp: item?.status?.secondaryStatus?.sourceDataTimestamp,
  }));

export const filterActiveRoboticMowersSummaryItems = (items: RoboticMowersSummaryItem[]) =>
  items
    .filter((item) => item.epos)
    .filter(
      (item) =>
        item?.status?.infoItems?.some(
          (infoItem) => infoItem.infoItemId === InfoItemEnum.MOWER_CURRENTLY_MOWED_AREA
        ) || item.status?.secondaryStatus?.status === SecondaryStatusRoboticMowerEnum.PAUSED
    );

export const compareFootprints = (
  footprints: RoboticMowersSummaryFootprintItem[],
  items: RoboticMowersSummaryItem[]
) => {
  const affectedMowers = filterActiveRoboticMowersSummaryItems(items);
  const different = footprints.some((footprint) => {
    const match = affectedMowers.find((item) => footprint.iprId === item.iprId);
    if (match) {
      return (
        match.status?.operationalStatus?.sourceDataTimestamp !==
          footprint.operationalStatusTimestamp ||
        match.status?.secondaryStatus?.sourceDataTimestamp !== footprint.secondaryStatusTimestamp
      );
    }

    // Nothing to compare with, so no change
    return false;
  });

  // Return true if no differences found
  return !different;
};

export const patchSentOperationStatusStepback = (
  originalResponseItem: AssetOperationExecuteResponse
): AssetOperationExecuteResponse => {
  if (originalResponseItem.status === OperationStatus.Sent) {
    return {
      ...originalResponseItem,
      // We get 'Sent' from BFF, but overwrite it with 'Posting'. The intention is to trust 'Sent' only once it is received via WS (typically almost immediately).
      status: OperationStatus.Posting as HfsOperationStatus,
    };
  }
  return originalResponseItem;
};
